import React, { useEffect } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";

import { Copyright, Policies, AccountCarousel } from "@/_components";
import LanguageSelector from "../_components/LanguageSelector";

import Login from "./Login";
import VerifyEmail from "./VerifyEmail";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import Transfer from "./Transfer";

import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    display: "flex",
    width: "80%",
    height: "80vh",
    marginLeft: "10%",
    marginTop: "10vh",
  },
  cardDetails: { display: "flex", flexDirection: "column" },
  root: {
    height: "100vh",
  },
  loginWrapper: {
    margin: theme.spacing(6, 4, 0),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: { margin: theme.spacing(4, 2, 0) },
  },
  logo: {
    width: 300,
    height: 61,
    [theme.breakpoints.down("sm")]: { width: 275, height: 55 },
  },
  carouselHolder: {
    backgroundColor: "#6da9b3",
    [theme.breakpoints.down("sm")]: { display: "none" },
  },
}));

function Account({ history, match }) {
  const classes = useStyles();
  const { path } = match;
  const { pathname } = useLocation();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const cookies = new Cookies();
  const user = cookies.get("lifesaferUser");
  const { t } = useTranslation();
  const source = pathname.slice(9, 17);

  document.title = "LifeSafer - My Account";

  useEffect(() => {
    // redirect to home if already logged in
    if (
      source !== "transfer" &&
      user !== undefined &&
      user.jwtToken !== undefined &&
      user.jwtToken !== null &&
      user.jwtToken.length > 20
    ) {
      history.push("/");
    } else if (source === "transfer") {
      // redirect to Transfer to handle silent entry from Client Enrollment
      let enrollmentCode = pathname.split("/").pop();
      if (enrollmentCode !== undefined) {
        cookies.set("ceCode", JSON.stringify(enrollmentCode), {
          path: "/",
          sameSite: "strict",
        });
        history.push(path + "/transfer");
      } else {
        cookies.remove("ceCode");
        history.push("/");
      }
    }
  }, []);

  return (
    <Grid container component="main" className={classes.root}>
      {source === "transfer" ? (
        <Switch>
          <Route exact path={`${path}/transfer`} component={Transfer} />
        </Switch>
      ) : (
        <>
          <Grid item xs={12} sm={4} md={6} className={classes.carouselHolder}>
            <AccountCarousel />
          </Grid>
          <Grid
            item
            xs={12}
            sm={8}
            md={6}
            component={Paper}
            elevation={6}
            square
          >
            <Grid
              container
              direction="row"
              justifyContent={isSmall ? "flex-end" : "center"}
              alignItems="center"
            >
              <Grid
                item
                style={{
                  marginLeft: isSmall ? 0 : 350,
                  paddingRight: isSmall ? 4 : 0,
                }}
              >
                <LanguageSelector />
              </Grid>
            </Grid>
            <div className={classes.loginWrapper}>
              <img
                className={classes.logo}
                src={"./src/_images/LogoLimited.png"}
                alt="LifeSafer"
              />
              <Typography
                variant="h6"
                style={{
                  paddingTop: 15,
                  paddingBottom: 15,
                  paddingLeft: 0,
                  cursor: "default",
                }}
              >
                {t("account.headerSlogan")}
              </Typography>
              <Switch>
                <Route exact path={`${path}/login`} component={Login} />
                <Route
                  exact
                  path={`${path}/verify-email`}
                  component={VerifyEmail}
                />
                <Route
                  exact
                  path={`${path}/forgot-password`}
                  component={ForgotPassword}
                />
                <Route
                  exact
                  path={`${path}/reset-password`}
                  component={ResetPassword}
                />
                <Redirect from="*" to={`${path}/login`} />
              </Switch>
            </div>
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              direction="column"
              style={{ paddingTop: 15 }}
            >
              <Grid item>
                <Policies />
              </Grid>
              <Grid item>
                <Copyright />
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
}

Account.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object.isRequired,
};

export default Account;
